import { useState } from 'react';

export type OwnerChangeAction = 'transfer' | 'detach' | 'delete';

interface Props {
  placeNumber: string;
  oldOwnerName: string;
  newOwnerName: string | null;
  boatCount: number;
  onConfirm: (action: OwnerChangeAction) => void | Promise<void>;
  onCancel: () => void;
}

export default function OwnerChangeDialog({
  placeNumber,
  oldOwnerName,
  newOwnerName,
  boatCount,
  onConfirm,
  onCancel,
}: Props) {
  const variant = newOwnerName ? 'with-new' : 'no-new';
  const [action, setAction] = useState<OwnerChangeAction>(
    variant === 'with-new' ? 'transfer' : 'detach',
  );

  return (
    <div
      role="dialog"
      aria-modal="true"
      className="fixed inset-0 bg-black/40 flex items-center justify-center p-4 z-50"
    >
      <div className="bg-white rounded-lg shadow-lg p-6 max-w-md w-full space-y-4">
        <h2 className="text-lg font-bold">Ägarbyte på plats {placeNumber}</h2>
        <p>
          Plats {placeNumber} har {boatCount} båt(ar) tillhörande{' '}
          <strong>{oldOwnerName}</strong>.
        </p>
        {variant === 'no-new' && (
          <p>Plats kommer få ingen ägare. Vad ska hända med båtarna?</p>
        )}
        {variant === 'with-new' && <p>Vad ska hända med dem?</p>}

        <fieldset className="space-y-2">
          {variant === 'with-new' && (
            <label className="flex items-center gap-2">
              <input
                type="radio"
                name="action"
                checked={action === 'transfer'}
                onChange={() => setAction('transfer')}
              />
              Flytta båtarna till {newOwnerName} (ny ägare)
            </label>
          )}
          <label className="flex items-center gap-2">
            <input
              type="radio"
              name="action"
              checked={action === 'detach'}
              onChange={() => setAction('detach')}
            />
            Frikoppla båtarna ({oldOwnerName} behåller båtarna utan plats)
          </label>
          <label className="flex items-center gap-2">
            <input
              type="radio"
              name="action"
              checked={action === 'delete'}
              onChange={() => setAction('delete')}
            />
            Radera båtarna permanent
          </label>
        </fieldset>

        <div className="flex justify-end gap-2 pt-2">
          <button type="button" onClick={onCancel} className="px-4 py-2 border rounded">
            Avbryt
          </button>
          <button
            type="button"
            onClick={() => void onConfirm(action)}
            className="px-4 py-2 bg-navy text-white rounded"
          >
            Bekräfta
          </button>
        </div>
      </div>
    </div>
  );
}
